import { B as BxfFormItem$1, d as defineCustomElement$1 } from './p-9a0171fa.js';

const BxfFormItem = BxfFormItem$1;
const defineCustomElement = defineCustomElement$1;

export { BxfFormItem, defineCustomElement };
